import { createI18nText } from '@hilma/netina2all';

const purchaseKitText = createI18nText({
    he: {
        kit: 'מוצר',
        item: 'מוצר',
        price: 'מחיר',
        quantity: 'כמות',
        numKits: "מס' מוצרים",
        total: 'סה"כ',
        kitIncludes: 'הסט כולל לולב, אתרוג, הדס, 2 סטים של ערבות, קוישיקלך ונרתיק לולב',
        shmitta: ' בנוסף, עקב שנת השמיטה התשלום עבור האתרוגים הינו דרך אוצר בית דין והינו לכיסוי הוצאות בלבד. התרומה מתייחסת לרכישת שאר המוצרים',
        aware: 'אני מודע לכך שהמוצר סגור ואינו ניתן להחלפה.',
        holders: 'אני מעוניין במספר אחר של נרתיקים \n (לסטים שאינם עבור נזקקים)',
        needyNotice: 'שימו לב, משלוח לנזקקים מועבר על ידנו ולא יגיע לאיסוף בנקודת החלוקה שתבחרו.',
        closeNotice: 'הבנתי',
        notAvailable: 'אזל מהמלאי',
    },
    en: {
        kit: 'Product',
        item: 'Item',
        price: 'Price',
        quantity: 'Quantity',
        numKits: 'Quantity',
        total: 'Total',
        kitIncludes: 'A set includes a Lulav, an Etrog, a Hadass, 2 sets of Aravah, Koishalach and a lulav holder',
        shmitta: 'Also, because of Shemitah I understand that the payment for the Etrog is through Otzar Beit Din and goes for covering costs only. The donation is made through purchasing the other species, not the Etrog.',
        aware: 'I am aware of the fact that the products are closed and cannot be exchanged.',
        holders: "I would like to purchase a different amount of holders (for sets that aren't for the needy)",
        needyNotice: 'Please note, the sets for the needy will be delivered by us and will not be collected at the distribution point you choose.',
        closeNotice: 'Ok',
        notAvailable: 'out of stock',
    }
});

export default purchaseKitText;